/** Oculta placeholders de dirección vacía del bootstrap. */
export function formatBranchLocation(location?: string | null): string | null {
  const value = location?.trim();
  if (!value) return null;
  const lower = value.toLowerCase();
  if (lower === 'dirección no cargada' || lower === 'direccion no cargada') return null;
  return value;
}

export function formatBranchCount(count: number): string {
  return count === 1 ? '1 sucursal' : `${count} sucursales`;
}
